import React from 'react';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { replaceI18nVariables } from '@/src/tools/tools';
import { useSelector } from 'react-redux';
import { currentSourceLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
const TranslationTip = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const sourceLanguage = useSelector(currentSourceLanguage());

  return (
    <div className={css.tipContainer}>
      <span className={css.tipText}>
        {replaceI18nVariables(getI18n('general.greenBarTip'), sourceLanguage)}
      </span>
    </div>
  );
};

export default TranslationTip;
